// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-navigation-template/src/index.tsx

import baseIcon, { navigationDefaultStyleSheetGetter, defaultNavigationIconGroupProps, defaultNavigationIconShapeSize } from '@bubble-ui/temp-icon-base';
var NavigationIconBanksCardsPath = 'M15.414 21H8a1 1 0 0 1-1-1v-8h14v4.414h2V10h-3.14l2.489-3.061L14.319 2l-3.154 4H8.11a3.073 3.073 0 0 0-3.1 2.74 2.617 2.617 0 0 0-.01.28V20a3 3 0 0 0 3 3h7.414v-2Zm-.59-16.167 4.417 2.757L17.283 10H10.6l4.225-5.167ZM7 8.91c.09-.538.565-.927 1.11-.91h1.507l-1.55 2H8a.949.949 0 0 1-.71-.31.885.885 0 0 1-.29-.67v-.11ZM26 23a3.97 3.97 0 0 0-.161-1.062l.99-.572-1-1.732-.98.566A3.994 3.994 0 0 0 23 19.142V18h-2v1.142a3.994 3.994 0 0 0-1.85 1.058l-.98-.566-1 1.732.992.572a3.584 3.584 0 0 0 0 2.124l-.991.572 1 1.732.98-.566c.51.514 1.149.88 1.85 1.058V28h2v-1.142a3.994 3.994 0 0 0 1.85-1.058l.98.566 1-1.732-.991-.572a3.97 3.97 0 0 0 .16-1.062Zm-4 2a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm-3-7h-2v-3h2v3Z';
var NavigationIconBanksCards = baseIcon('NavigationIconBanksCards', {
  getPath: () => NavigationIconBanksCardsPath,
  defaultStyleSheetGetter: navigationDefaultStyleSheetGetter,
  groupProps: defaultNavigationIconGroupProps,
  shapeSize: defaultNavigationIconShapeSize
});
export default NavigationIconBanksCards;
//# sourceMappingURL=index.js.map